jQuery(function ($) {
  const animNum = (EL) => {
    if (EL._isAnimated) return;
    EL._isAnimated = true;

    $(EL)
      .prop("Counter", 0)
      .animate(
        {
          Counter: EL.dataset.num,
        },
        {
          duration: 3000,
          step: function (now) {
            if (EL.dataset.num % 1 == 0) text = Math.ceil(now); 
            else text = now.toFixed(1);
            $(this).html(numberWithSpaces(text));
          },
        }
      );
  };

  const inViewport = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) animNum(entry.target);
    });
  };

  $("[data-num]").each((i, EL) => {
    const observer = new IntersectionObserver(inViewport);
    observer.observe(EL);
  });

  function numberWithSpaces(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  }
});
